<template>
  <b-modal
    :visible="show"
    title="Inclusão em lote"
    @hide="$emit('close')"
    centered
    hide-footer
  >
    <b-form @submit.prevent="handleSubmit">

      <div class="info-box mb-3 p-1">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <strong>Importação em lote</strong>
            <p class="small ">
              Utilize o modelo padrão para evitar erros no processamento.
            </p>
          </div>

           <b-button
            variant="secondary"
            size="sm"
            @click="downloadTemplate"
            class="d-flex align-items-center"
        >
            <i class="fas fa-download mr-1"></i>
            Modelo
        </b-button>

        </div>
      </div>

      <b-form-group label="Arquivo Excel" label-class="font-weight-bold">
        <b-form-file
          v-model="file"
          accept=".xlsx, .xls, .xlsm"
          browse-text="Selecionar"
          placeholder="Nenhum arquivo selecionado"
          drop-placeholder="Arraste o arquivo aqui..."
          class="custom-file-upload"
        />
        <small class="text-muted">
          Formatos permitidos: .xlsx, .xls, .xlsm
        </small>
      </b-form-group>

      <div v-if="fileError" class="alert alert-danger py-2">
        {{ fileError }}
      </div>

      <div v-if="file" class="file-preview mb-3 p-2">
        <i class="fas fa-file-excel text-success mr-2"></i>
        {{ file.name }}
      </div>

      <div class="d-flex justify-content-between align-items-center mt-4">

        <b-button variant="outline-secondary" @click="$emit('close')">
          Cancelar
        </b-button>

        <b-button
          variant="primary"
          type="submit"
          :disabled="!file"
        >
          <i class="fas fa-upload mr-1"></i>
          Enviar arquivo
        </b-button>

      </div>

    </b-form>
  </b-modal>
</template>
<script>
import BlacklistService from '@/service/blacklist'
import {
  BModal,
  BForm,
  BFormGroup,
  BFormFile,
  BButton
} from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormFile,
    BButton
  },

  props: {
    show: Boolean
  },

  data() {
    return {
      file: null,
      fileError: null
    }
  },

  computed: {
    isValidFile() {
      if (!this.file) return null

      const allowed = ['xlsx', 'xls', 'xlsm']
      const ext = this.file.name.split('.').pop().toLowerCase()

      return allowed.includes(ext)
    }
  },

  methods: {
    handleSubmit() {
      if (!this.file) {
        this.fileError = 'Selecione um arquivo'
        return
      }

      if (!this.isValidFile) {
        this.fileError = 'Formato inválido'
        return
      }

      this.fileError = null

      this.$emit('submit', this.file)
      this.reset()
      this.$emit('close')
    },

    async downloadTemplate() {
      try {
        const response = await BlacklistService.getTemplateUrl()

        const fileUrl = response.data.url

        const link = document.createElement('a')
        link.href = fileUrl
        link.target = '_blank'
        link.setAttribute('download', '')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)

      } catch (error) {
        console.error(error)
        this.$toast.error('Erro ao baixar modelo')
      }
    },

    reset() {
      this.file = null
      this.fileError = null
    }
  }
}
</script>
<style scoped>
.info-box {
  background: #f8f9fa;
  border-left: 4px solid var(--warning);
  background-color: #faf2e3;
  border-radius: 6px;
  color:rgb(95, 95, 95)
}

.file-preview {
  background: #f1f3f5;
  border-radius: 6px;
  font-size: 14px;
}

.custom-file-upload .custom-file-input:focus ~ .custom-file-label {
  border-color: #007bff;
  box-shadow: none;
}
</style>